import { render, staticRenderFns } from "./PromotionPricing.vue?vue&type=template&id=79990fe4&"
import script from "./PromotionPricing.vue?vue&type=script&lang=js&"
export * from "./PromotionPricing.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPricing.vue?vue&type=style&index=0&id=79990fe4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports